import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { computed } from 'vue';
    import type { SelectOption } from '@/types';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeAddressForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { tm } = useI18n();

    const countryOptions = computed<SelectOption[]>(() => {
        const map = tm('employee.address.country_codes_array') as Record<string, string>;
        return Object.entries(map).map(([value, label]) => ({ value, label }));
    });

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "address",
      label: "employee.address.address",
      "error-key": "address.main.address"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "address",
          modelValue: _ctx.form.address.main.address,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.address.main.address) = $event)),
          placeholder: _ctx.$t('employee.address.address')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "address2",
      label: "employee.address.address2"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "address2",
          modelValue: _ctx.form.address.main.address2,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.address.main.address2) = $event)),
          placeholder: _ctx.$t('employee.address.address2')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "postal_code",
      label: "employee.address.postal_code",
      "error-key": "address.main.postal_code"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "postal_code",
          modelValue: _ctx.form.address.main.postal_code,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.address.main.postal_code) = $event)),
          placeholder: _ctx.$t('employee.address.postal_code'),
          type: "number",
          step: "any"
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "city",
      label: "employee.address.city",
      "error-key": "address.main.city"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "city",
          modelValue: _ctx.form.address.main.city,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address.main.city) = $event)),
          placeholder: _ctx.$t('employee.address.city')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "country_code",
      label: "employee.address.country_code"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          id: "country_code",
          modelValue: _ctx.form.address.main.country_code,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.address.main.country_code) = $event)),
          options: countryOptions.value,
          placeholder: _ctx.$t('employee.address.country_code'),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})